import type { PropsWithChildren } from "react";
import { useLocation, useNavigate } from "react-router";
import { createReactRouterAdapter, MultiTourKitProvider } from "@tour-kit/react";
import DefinityTourShell from "../DefinityTourShell/DefinityTourShell";
import {
  trackTourCompleted,
  trackTourSkipped,
  trackTourStarted,
  trackTourStep,
} from "../onboarding.analytics";
import RegisteredTours from "../RegisteredTours/RegisteredTours";
import TourAutoScroll from "../TourAutoScroll/TourAutoScroll";
import TourFab from "../TourFab/TourFab";
import TourKeyboard from "../TourKeyboard/TourKeyboard";

const useTourRouterAdapter = createReactRouterAdapter(useLocation, useNavigate);

const DefinityTourProvider = ({ children }: PropsWithChildren) => {
  const router = useTourRouterAdapter();

  return (
    <MultiTourKitProvider
      router={router}
      config={{
        persistence: { enabled: true, keyPrefix: "definity:tours" },
      }}
      onTourStart={trackTourStarted}
      onStepView={trackTourStep}
      onTourComplete={trackTourCompleted}
      onTourSkip={trackTourSkipped}
    >
      {children}
      <RegisteredTours />
      <DefinityTourShell />
      <TourAutoScroll />
      <TourKeyboard />
      <TourFab />
    </MultiTourKitProvider>
  );
};

export default DefinityTourProvider;
